import $ from 'jquery';
import {setElementsFromScope } from "./../../utilities/selectorHelpers";
import render from "./../../utilities/render";
import assign from 'object-assign';

const EditChecker = createEditChecker();

function createEditChecker() {
	let pageIsDirty = false;

	const elementsMap = {
		menu : "#side-menu",
		dockbar : "#_145_dockbar"
	};

	const els = {};

	let buttonClass = "purple-btn";

	let modal = $();

	let checker = assign({
		isDirty(){
			return pageIsDirty;
		},
		setPageDirty(){
			pageIsDirty = true;
		},
		setPageClean(){
			pageIsDirty = false;
		},
		setButtonClass(cls){
			buttonClass = cls;
		},
		bindNavigation(){
			//Setup event listeners for various page elements
			setElementsFromScope(els, elementsMap, $(document));

			els.menu.on("click", ".nav-redirect-link", handleNavigationEvent);
			els.dockbar.on("click", ".dropdown-menu a", handleNavigationEvent);

			//Fallback to browser handling if click event is not caught
			$(window).bind('beforeunload', function () {
				if(pageIsDirty)
					return 'There is unsaved data on this page, are you sure you want to leave?';
			});
		},
		bindCustomNavigation(parent, event, selector){
			$(parent).on(event, selector, handleNavigationEvent);
		},
		bindChangeListener(selector){
			const self = this;
			$(selector).on("change", function(e){
				handleChangeListener();
			});
		},
		bindCancelButton(selector){
			const self = this;
			$(selector).on("click", function(e){
			 	e.preventDefault();

				if(!$(this).hasClass('disabled')){
					self.showCancelModal({
					redirectUrl: $(this).data("edit-checker-redirect")
					});
				}
			});
		},
		showCancelModal(spec={}){
			const defaultSpec = {
				title: "Cancel",
	      body: "<div class='q-marg-all-xl'>Are you sure you'd like to cancel? Your work will not be saved.</div>",
	      allowButton: "Leave Page",
	      denyButton: "Stay"
			};

			const options = $.extend({}, defaultSpec, spec);

			this.showModal(options);
		},
		showModal(spec={}){
			const self = this;
			const defaultSpec = {
				title : "Unsaved Information",
				body : "<div class='q-marg-all-xl'>By leaving this page, you will lose all unsaved work. Would you like to continue?</div>",
				allowButton : "Leave Page",
				denyButton : "Stay",
				btnClass : buttonClass
			};

			const options = $.extend({}, defaultSpec, spec);

			if(this.isDirty()){
				if(options.isDirtyCallback && typeof options.isDirtyCallback === "function"){
					options.isDirtyCallback();
				}

				generateModal(options);
				modal.modal('show');

				modal.on("click", ".allow-navigation-btn", function(){
					self.setPageClean();
					if(options.allowCallback && typeof options.allowCallback === "function"){
						options.allowCallback();
					}

					if(options.redirectUrl){
						window.location.href = options.redirectUrl;
					}
				});

				modal.on("click", ".deny-navigation-btn", function(){
					self.hideModal();
					if(options.denyCallback && typeof options.denyCallback === "function"){
						options.denyCallback();
					}
				});
			}else{
				if(options.allowCallback && typeof options.allowCallback === "function"){
					options.allowCallback();
				}

				if(options.redirectUrl){
					window.location.href = options.redirectUrl;
				}
			}
		},
		hideModal(){
			modal.modal('hide');
		}
	});

	function generateModal(options) {
		modal.remove();
		const modalBtns  = `<button type="button" class="base-btn v2-btn ${options.btnClass} allow-navigation-btn">${options.allowButton}</button>
		                    <button type="button" class="base-btn ${options.btnClass} deny-navigation-btn">${options.denyButton}</button>`;
		options.footerBtns = modalBtns;
    modal = $(render(require("../../sharedHtml/modal.html"), options));
    $("body").append(modal);
  };

	function handleNavigationEvent(e){
		if (pageIsDirty){
			e.preventDefault();
			checker.showModal({
				redirectUrl : $(this).attr("href")
			});
		}
	}

	function handleChangeListener(){
		checker.setPageDirty();
	}

	return checker;
}

window.EditChecker = EditChecker;
export default EditChecker;



// WEBPACK FOOTER //
// ./src/components/EditChecker/EditChecker.js